import { Box, IconButton, Stack, Typography, styled } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useState } from 'react';
import {
  DownloadCoperaChatAndroidSVG,
  DownloadCoperaChatAppleSVG,
} from 'src/assets/illustrations';
import Iconify from 'src/components/iconify';
import { useBreakpoints } from 'src/hooks/useBreakpoints';
import { useLocales } from 'src/locales';
import QuadriculadoTexture from '/assets/background/quadriculado-background-texture.png';

export const GuestGatheringLobbyMobileDetector = () => {
  const { isSmallMobile } = useBreakpoints();
  const [isVisible, setIsVisible] = useState(true);
  const theme = useTheme();
  const { translate } = useLocales();

  const handleClose = () => setIsVisible(false);

  if (!isSmallMobile || !isVisible) return null;

  return (
    <StyledRoot>
      <StyledCloseButton onClick={handleClose}>
        <Iconify icon="tabler:x" sx={{ color: 'white' }} />
      </StyledCloseButton>

      <StyledContent>
        <Typography
          variant="h3"
          sx={{ textAlign: 'center', fontWeight: 'bold' }}
        >
          {translate('communicate.join_conference.mobile.get_the_app')}
        </Typography>

        <Typography
          sx={{
            color: theme.palette.text.secondary,
            textAlign: 'center',
            mb: 4,
            maxWidth: 400,
            lineHeight: 1.6,
          }}
        >
          {translate('communicate.join_conference.mobile.best_experience')}
        </Typography>

        <Stack direction="row" spacing={2}>
          <a
            href="https://apps.apple.com/br/app/copera-chat/id6596778963"
            target="_blank"
            rel="noreferrer"
          >
            <DownloadCoperaChatAppleSVG />
          </a>

          <a
            href="https://play.google.com/store/apps/details?id=com.copera.communicate"
            target="_blank"
            rel="noreferrer"
          >
            <DownloadCoperaChatAndroidSVG />
          </a>
        </Stack>
      </StyledContent>
    </StyledRoot>
  );
};

const StyledRoot = styled('div')(() => ({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 9999,

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: '#000',

  backgroundImage: ` url(${QuadriculadoTexture})`,
  backgroundPosition: 'top',
  backgroundRepeat: 'no-repeat',

  overflow: 'hidden',

  '&::before': {
    content: '""',
    position: 'absolute',
    top: '-10%',
    left: '50%',
    transform: 'translateX(-50%)',
    width: '70%',
    height: '20%',
    background: 'rgba(47,85,234,0.5)',
    filter: 'blur(100px)',
    borderRadius: '50%',
    zIndex: 1,
  },

  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: '-15%',
    left: '50%',
    transform: 'translateX(-50%)',
    width: '30%',
    height: '20%',
    background: 'rgba(100,73,204,0.5)',
    filter: 'blur(100px)',
    borderRadius: '50%',
    zIndex: 1,
  },
}));

const StyledCloseButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(2),
  right: theme.spacing(2),
  zIndex: 3,
  width: 48,
  height: 48,
  backgroundColor: theme.palette.grey[900],
  border: `1px solid ${theme.palette.grey[800]}`,
}));

const StyledContent = styled(Box)(({ theme }) => ({
  position: 'relative',
  zIndex: 2,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(4),
  textAlign: 'center',
}));
